import { updateCurrentUserData } from "./currentUserActions";
import {
  LOGIN,
  LOGIN_ERROR,
  LOGOUT,
  LOGOUT_ERROR,
  RESET_STORE,
  CHANGE_LOGIN_STATUS,
  CLEAN_STORE,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_ERROR,
  MANUALLY_TRIGGER_AUTENTICATION,
  RESET_PASSWORD,
  RESET_PASSWORD_ERROR
} from "../types";

import { LoginFormProps } from "../../types/actions/credentials";
import { getCurrentUserData } from "../actions/currentUserActions";

import Cookies from "js-cookie";

import * as api from "../../api/axiosBase";

export const login =
  (formData: LoginFormProps, history: any) => async (dispatch) => {
    try {
      const { data } = await api.signIn(formData);
      dispatch({ type: LOGIN, payload: data.status });
      Cookies.set("jwt", data.token);
      dispatch(getCurrentUserData());
      //history.push("/");
      localStorage.setItem("isAuthenticated", "true");
      window.location.href = "/";
    } catch (error) {

      dispatch({ type: LOGIN_ERROR, payload: error.response.data.status });
      dispatch({ type: LOGIN_ERROR, payload: error.response.data.message });
    }
  };

/*export const resetStore = () => (dispatch) => {
  console.log("l");
  dispatch({ type: RESET_STORE, payload: [] });
};*/

export const logout = (history: any) => (dispatch) => {
  dispatch({ type: LOGOUT });
  Cookies.remove("jwt");
  localStorage.clear();
  history.push("/signin");
};

export const cleanStore = () => (dispatch) => {
  dispatch({ type: CLEAN_STORE });
};

export const changeLoginStatus = (dispatch) => {
  dispatch({ type: CHANGE_LOGIN_STATUS });
};

/*export const logout = (token) => async (dispatch) => {
  try {
    const response = await instance.post(logoutRoute, { ...token });
    dispatch({ type: LOGOUT, payload: response.data.message });
    Cookies.remove("access");
    Cookies.remove("user_info");
    Cookies.remove("votedModels");
    Cookies.remove("selectedModel");
    Cookies.remove("is_active");
    //Router.push("/signin");
  } catch (e) {
    dispatch({ type: LOGOUT_ERROR, payload: e.message });
  }
};*/

// forgot password action

// forgot password
export const forgotPassword = (formData: any, history) => async (dispatch) => {
  try {
    const { data } = await api.forgotPassword(formData);
    dispatch({ type: FORGOT_PASSWORD, payload: data });

  } catch (error) {
    dispatch({
      type: FORGOT_PASSWORD_ERROR,
      payload: error.response.data
    });
  }
};

// reset reset password
export const resetPassword =
  (formData: any, id: string, history) => async (dispatch) => {
    try {
      const { data } = await api.resetPassword(formData, id);
      dispatch({ type: RESET_PASSWORD, payload: data });

    } catch (error) {
      dispatch({
        type: RESET_PASSWORD_ERROR,
        payload: error.response.data
      });
    }
  };

// manually add autentication status
export const manuallyTriggerAutentication = (message: string) => (dispatch) => {
  dispatch({ type: MANUALLY_TRIGGER_AUTENTICATION, payload: message });
};
